<div class="author">
  <div class="flex gap-4 pb-4">
    <div class="author__image">
      @if (landingPageDataService.details().user?._id) {
        <img
          [src]="landingPageDataService.details().user?.picturePath"
          alt="author-img"
        />
      } @else {
        <img src="/assets/media/svg/circle-user-solid.svg" alt="author-img" />
      }
    </div>

    <div class="author__details">
      <div class="author__name flex items-center gap-2">
        @if (landingPageDataService.details().user?._id) {
          <p
            [title]="landingPageDataService.details().user?.fullName"
            [innerText]="
              landingPageDataService.details().user?.fullName || ''
                | ellipsis: 14
            "
          ></p>
        } @else {
          <p translate="Anonymous User"></p>
        }
        <div
          inlineSVG="landing/verify.svg"
          class="verify__icon"
          [ngClass]="{ active: landingPageDataService.details().user?._id }"
        ></div>
      </div>

      <p
        class="author__joining mt-2"
        [innerText]="
          landingPageDataService.details().createdAt
            | date: 'MMMM d \'at\' h:mm a'
        "
      ></p>
    </div>
  </div>
</div>
